import React from 'react';
import styled from 'styled-components';
import ShapeTypeItem, { ShapeType } from './resizableShapeTypeItem';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 24px;

    @media (max-width: 1475px) {
        gap: 15px;
    }
`;

interface IShapeTypeSectionProps {
    selectedShape: number;
    onShapeChange: (shape: number) => void;
}

const ShapeTypeSection = ({ selectedShape, onShapeChange }: IShapeTypeSectionProps) => {
    const handleOnClickShapeItem = (type: ShapeType) => {
        const shapeValue = type === 'rectangle' ? 0 : 1;
        onShapeChange(shapeValue);
    };

    return (
        <Container>
            <ShapeTypeItem type='rectangle' selected={selectedShape === 0} onClick={() => handleOnClickShapeItem('rectangle')} />
            <ShapeTypeItem type='circle' selected={selectedShape === 1} onClick={() => handleOnClickShapeItem('circle')} />
        </Container>
    );
};

export default ShapeTypeSection;
